
export const insightsData = [
  // 히트 코어루프
  {
    id: 1,
    category: 'core-loop',
    title: 'We Are Warriors의 영원한 생명력',
    excerpt: 'Lessmore UG가 개발한 하이브리드 캐주얼 게임 We Are Warriors. 자동 전진과 자원 관리의 완벽한 조화로 글로벌 5천만 다운로드를 돌파한 성공 비결을 분석합니다.',
    date: '2026-01-15',
    categoryColor: '#8b4513',
    content: `# We Are Warriors의 영원한 생명력

Lessmore UG가 개발한 하이브리드 캐주얼 게임 We Are Warriors는 2020년 출시 이후 지금까지 꾸준한 인기를 유지하며 글로벌 5천만 다운로드를 돌파했습니다.

## 핵심 메커니즘

### 자동 전진 시스템
플레이어는 직접 캐릭터를 조작하지 않습니다. 유닛들이 자동으로 전진하며 적과 조우하면 자동으로 전투를 시작합니다. 이 단순함이 게임의 핵심 강점입니다.

### 자원 관리의 묘미
- 제한된 자원으로 유닛 소환
- 전략적 유닛 배치
- 타이밍에 따른 승패 결정

## 성공 요인

### 1. 낮은 진입 장벽
복잡한 조작 없이 누구나 쉽게 플레이할 수 있습니다. 터치 한 번으로 유닛을 소환하는 직관적인 인터페이스가 핵심입니다.

### 2. 전략적 깊이
단순해 보이지만 유닛 조합, 자원 관리 등 전략적 요소가 풍부합니다.

### 3. 짧은 세션
한 판이 1‑2분으로 짧아 언제 어디서나 즐길 수 있습니다.

## 수익화 전략

- 광고 기반 보상 시스템
- 선택적 IAP (In‑App Purchase)
- 강제성 없는 자연스러운 수익화

> "단순함 속의 깊이, 그것이 We Are Warriors의 성공 비결입니다."

## 결론

We Are Warriors는 하이브리드 캐주얼 게임의 교과서와 같은 작품입니다. 자동 전진과 자원 관리라는 두 가지 핵심 메커니즘의 완벽한 조화가 만들어낸 걸작입니다.`
  },
  {
    id: 2,
    category: 'core-loop',
    title: 'Eatventure의 방치형 타이쿤 중독성',
    excerpt: 'Lessmore UG의 방치형 레스토랑 타이쿤 게임 Eatventure. 직관적인 탭 메커니즘과 레스토랑 확장의 만족감이 만들어낸 5천만 다운로드의 비밀을 탐구합니다.',
    date: '2026-01-12',
    categoryColor: '#8b4513',
    content: `# Eatventure의 방치형 타이쿤 중독성

Lessmore UG의 또 다른 히트작 Eatventure는 방치형 레스토랑 타이쿤 게임으로 5천만 다운로드를 돌파하며 장르의 새로운 기준을 제시했습니다.

## 핵심 메커니즘

### 탭 기반 수익 창출
화면을 탭하면 음식이 생산되고 수익이 발생합니다. 이 단순한 메커니즘이 놀라운 중독성을 만들어냅니다.

### 레스토랑 확장 시스템
- 새로운 음식 메뉴 추가
- 레스토랑 업그레이드
- 새로운 지역 오픈

## 성장 곡선 설계

### 초반: 빠른 성장
처음에는 빠르게 성장하며 플레이어에게 성취감을 제공합니다.

### 중반: 전략적 선택
어떤 레스토랑을 먼저 업그레이드할지 전략적 선택이 필요합니다.

### 후반: 장기 목표
새로운 지역 오픈이라는 큰 목표가 플레이어를 계속 게임에 머물게 합니다.

## 방치형 요소

게임을 종료해도 수익이 계속 발생합니다. 이는 플레이어가 부담 없이 게임을 즐길 수 있게 하며, 동시에 다시 접속하게 만드는 강력한 동기가 됩니다.

## 수익화 전략

- 광고 시청으로 수익 2배
- 오프라인 수익 증가 IAP
- 특별 이벤트 패키지

> "탭의 즐거움과 성장의 만족감, Eatventure는 방치형 게임의 완성형입니다."

## 결론

Eatventure는 단순한 탭 메커니즘과 레스토랑 확장의 만족감을 완벽하게 결합한 방치형 타이쿤 게임의 걸작입니다.`
  },
  {
    id: 3,
    category: 'core-loop',
    title: 'Gear Fight의 톱니바퀴 퍼즐 혁명',
    excerpt: 'Voodoo가 퍼블리싱한 톱니바퀴 배치 퍼즐 + 타워 디펜스 하이브리드 게임 Gear Fight. 톱니바퀴를 연결해 기계를 만들고 적을 물리치는 독특한 메커니즘으로 2025년 3천만 다운로드를 기록한 성공 비결을 분석합니다.',
    date: '2026-01-10',
    categoryColor: '#8b4513',
    content: `# Gear Fight의 톱니바퀴 퍼즐 혁명

Voodoo가 퍼블리싱한 Gear Fight는 톱니바퀴 배치 퍼즐과 타워 디펜스를 결합한 혁신적인 하이브리드 게임으로 2025년 3천만 다운로드를 기록했습니다.

## 핵심 메커니즘

### 톱니바퀴 연결 시스템
플레이어는 톱니바퀴를 배치하고 연결하여 기계를 만듭니다. 톱니바퀴가 맞물리면 회전하며 에너지를 전달합니다.

### 타워 디펜스 요소
- 적이 경로를 따라 진격
- 톱니바퀴 기계로 적 공격
- 전략적 배치가 승패 결정

## 독창적인 장르 결합

### 퍼즐의 만족감
톱니바퀴를 정확히 연결했을 때의 만족감이 뛰어납니다. 기계가 작동하는 모습을 보는 것만으로도 즐겁습니다.

### 디펜스의 긴장감
적이 다가오는 긴장감과 기계로 적을 물리치는 쾌감이 조화를 이룹니다.

## 성공 요인

### 1. 직관적인 메커니즘
톱니바퀴를 드래그하여 배치하는 단순한 조작으로 누구나 쉽게 플레이할 수 있습니다.

### 2. 시각적 만족감
톱니바퀴가 맞물려 회전하는 모습이 시각적으로 매우 만족스럽습니다.

### 3. 전략적 깊이
단순해 보이지만 톱니바퀴 배치에 따라 효율이 크게 달라지는 전략적 깊이가 있습니다.

## 레벨 디자인

각 레벨은 독특한 지형과 적 배치로 플레이어에게 새로운 도전을 제공합니다. 난이도 곡선이 완만하여 초보자도 쉽게 적응할 수 있습니다.

> "톱니바퀴의 물리적 만족감과 디펜스의 전략성, Gear Fight는 장르 결합의 교과서입니다."

## 결론

Gear Fight는 톱니바퀴 퍼즐과 타워 디펜스를 완벽하게 결합하여 새로운 장르를 창조한 혁신적인 게임입니다.`
  },
  {
    id: 16,
    category: 'core-loop',
    title: '스팀에서 모바일로: 감정 추출 전략',
    excerpt: 'PC 게임의 복잡한 메커니즘에서 핵심 감정 1-2가지만 추출해 모바일로 성공한 사례들. Vampire Survivors에서 탕탕특공대로, Overcooked에서 Eatventure로, ARK에서 Dino Mutant로 이어지는 감정 이식의 비밀을 분석합니다.',
    date: '2026-01-22',
    categoryColor: '#8b4513',
    content: `# 스팀에서 모바일로: 감정 추출 전략

PC 게임의 복잡한 메커니즘에서 핵심 감정 1-2가지만 추출해 모바일로 성공한 사례들을 분석합니다.

## 감정 추출의 원칙

### 1. 핵심 감정 식별
PC 게임이 주는 여러 감정 중 가장 강력한 1-2가지를 선택합니다.

### 2. 메커니즘 단순화
복잡한 조작을 제거하고 핵심 감정만 남깁니다.

### 3. 모바일 최적화
짧은 세션과 터치 조작에 맞게 재설계합니다.

## 성공 사례

### Vampire Survivors → 탕탕특공대
**추출된 감정:** 압도적인 화력의 쾌감
- 복잡한 빌드 시스템 단순화
- 자동 공격으로 조작 간소화
- 귀여운 비주얼로 대중화

### Overcooked → Eatventure
**추출된 감정:** 레스토랑 성장의 만족감
- 협동 요소 제거
- 타이밍 압박 제거
- 방치형으로 재해석

### ARK → Dino Mutant
**추출된 감정:** 공룡 수집과 진화의 즐거움
- 생존 요소 제거
- 건설 요소 제거
- 수집과 합성에 집중

## 감정 추출 프로세스

### 1단계: 게임 플레이 분석
PC 게임을 직접 플레이하며 어떤 순간에 가장 강한 감정을 느끼는지 기록합니다.

### 2단계: 감정 순위 매기기
느낀 감정들을 강도 순으로 정렬합니다.

### 3단계: 모바일 적합성 평가
각 감정이 모바일에서 구현 가능한지 평가합니다.

### 4단계: 메커니즘 재설계
선택된 감정을 모바일에서 구현할 최소한의 메커니즘을 설계합니다.

## 주의사항

### 저작권 존중
감정은 추출하되, 비주얼과 스토리는 완전히 새롭게 만들어야 합니다.

### 과도한 단순화 경계
너무 단순화하면 원작의 매력이 사라질 수 있습니다.

> "복잡함을 제거하되, 감정은 그대로. 그것이 감정 추출의 핵심입니다."

## 결론

스팀 게임의 감정 추출 전략은 검증된 재미를 모바일로 가져오는 효과적인 방법입니다.`
  },
  {
    id: 19,
    category: 'core-loop',
    title: 'Block Jam 3D - 슬라이드 퍼즐의 완벽한 3D 진화',
    excerpt: 'Voodoo가 퍼블리싱한 Block Jam 3D는 클래식 Rush Hour 보드게임을 3D로 재해석한 퍼즐 게임입니다. 블록을 슬라이드하여 특정 블록을 탈출시키는 단순하지만 중독적인 메커니즘으로 1억 다운로드를 돌파하며 퍼즐 장르의 새로운 기준을 제시했습니다.',
    date: '2026-01-26',
    categoryColor: '#8b4513',
    content: `# Block Jam 3D - 슬라이드 퍼즐의 완벽한 3D 진화

Voodoo가 퍼블리싱한 Block Jam 3D는 클래식 Rush Hour 보드게임을 3D로 재해석한 퍼즐 게임으로 1억 다운로드를 돌파했습니다.

## 핵심 메커니즘

### 슬라이드 블록 시스템
블록을 좌우 또는 상하로 슬라이드하여 특정 블록(주로 빨간색)을 출구로 이동시키는 것이 목표입니다.

### 3D 비주얼
2D 보드게임을 3D로 재해석하여 시각적 만족감을 크게 높였습니다.

## 성공 요인

### 1. 직관적인 조작
블록을 드래그하는 단순한 조작으로 누구나 쉽게 플레이할 수 있습니다.

### 2. 점진적 난이도
초반에는 쉽게 시작하여 점차 복잡해지는 완만한 난이도 곡선이 특징입니다.

### 3. 짧은 세션
한 판이 1-3분으로 짧아 언제 어디서나 즐길 수 있습니다.

### 4. 만족스러운 피드백
블록이 슬라이드되는 애니메이션과 사운드가 매우 만족스럽습니다.

## 레벨 디자인

### 초급: 3-5개 블록
기본 메커니즘을 익히는 단계입니다.

### 중급: 6-8개 블록
여러 블록을 순차적으로 움직여야 하는 전략이 필요합니다.

### 고급: 9개 이상 블록
복잡한 퍼즐을 풀기 위해 여러 단계를 미리 계획해야 합니다.

## 수익화 전략

- 힌트 시스템 (광고 또는 IAP)
- 레벨 스킵 옵션
- 광고 제거 패키지

> "단순함의 극치, Block Jam 3D는 퍼즐 게임의 본질을 보여줍니다."

## 결론

Block Jam 3D는 클래식 퍼즐을 현대적으로 재해석하여 대중화에 성공한 모범 사례입니다.`
  },

  // 패스트 팔로워
  {
    id: 4,
    category: 'fast-follower',
    title: '성공작 베리에이션 전략',
    excerpt: '히트작을 따라하되 더 나은 경험을 제공하는 법. 베리에이션 게임 개발 시 핵심 메커니즘은 유지하면서 독자적 가치를 창출하는 전략을 소개합니다.',
    date: '2026-01-08',
    categoryColor: '#2f4f4f',
    content: `# 성공작 베리에이션 전략

히트작을 따라하되 더 나은 경험을 제공하는 패스트 팔로워 전략을 소개합니다.

## 베리에이션의 원칙

### 1. 핵심 메커니즘 유지
원작의 핵심 재미를 만들어내는 메커니즘은 반드시 유지해야 합니다. 이것이 검증된 재미의 근원입니다.

### 2. 차별화 요소 추가
단순히 복사하는 것이 아니라 독자적인 가치를 추가해야 합니다.

### 3. 개선된 경험
원작의 불편한 점을 개선하여 더 나은 경험을 제공합니다.

## 차별화 전략

### 테마 변경
같은 메커니즘이라도 테마를 바꾸면 완전히 다른 게임이 됩니다.

**예시:**
- 중세 전쟁 → 현대 전쟁
- 레스토랑 → 카페
- 공룡 → 로봇

### 비주얼 스타일
- 3D → 2D
- 리얼리스틱 → 귀여운
- 다크 → 밝은

### 타겟 유저
- 글로벌 → 로컬
- 남성 → 여성
- 성인 → 어린이

## 성공 사례

### 사례 1: 고양이 스낵바
Eatventure의 메커니즘을 유지하면서 귀여운 고양이 테마로 변경하여 한국 시장에서 성공했습니다.

### 사례 2: 블럭냥!
Block Jam 3D의 메커니즘을 유지하면서 고양이 캐릭터와 스토리를 추가하여 차별화했습니다.

## 주의사항

### 법적 문제
- 저작권 침해 주의
- 상표권 확인
- 특허 검토

### 윤리적 고려
원작 개발사를 존중하며 명백한 복제는 피해야 합니다.

> "베리에이션은 복사가 아닌 재해석입니다."

## 결론

성공작 베리에이션은 검증된 재미를 빠르게 시장에 선보이면서도 독자적인 가치를 창출하는 효과적인 전략입니다.`
  },
  {
    id: 5,
    category: 'fast-follower',
    title: 'Idle Outpost - Eatventure 메커니즘의 우주 기지 변형',
    excerpt: '앱퀀텀의 Eatventure에서 영감을 받아 방치형 레스토랑 타이쿤을 우주 기지 테마로 재해석한 Idle Outpost. 검증된 메커니즘을 새로운 테마로 성공적으로 변형한 사례를 분석합니다.',
    date: '2026-01-05',
    categoryColor: '#2f4f4f',
    content: `# Idle Outpost - Eatventure 메커니즘의 우주 기지 변형

Idle Outpost는 앱퀀텀의 히트작 Eatventure의 방치형 레스토랑 타이쿤 메커니즘을 우주 기지 건설 테마로 성공적으로 변형한 사례입니다.

## 원작 분석: Eatventure

### 핵심 메커니즘
- 탭 기반 수익 창출
- 시설 확장 및 업그레이드
- 방치형 수익 시스템
- 새로운 지역 언락

## Idle Outpost의 변형 전략

### 1. 테마 변경
레스토랑 → 우주 기지로 테마를 완전히 변경했습니다.

**레스토랑 요소 → 우주 기지 요소**
- 음식 생산 → 자원 채굴
- 레스토랑 확장 → 기지 건설
- 새로운 메뉴 → 새로운 시설
- 손님 만족도 → 우주 탐사 진행도

### 2. 비주얼 차별화
Eatventure의 밝고 귀여운 레스토랑 비주얼 대신, SF 감성의 우주 기지 디자인을 적용했습니다.

### 3. 진행 구조 유지
원작의 검증된 진행 구조는 그대로 유지했습니다:
- 초반: 빠른 성장으로 성취감 제공
- 중반: 전략적 업그레이드 선택
- 후반: 새로운 구역 오픈이라는 큰 목표

## 차별화 포인트

### 스토리 요소 강화
단순한 경영 시뮬레이션을 넘어 우주 탐사라는 스토리를 추가하여 몰입감을 높였습니다.

### 수집 요소 추가
다양한 우주 탐사 장비와 로봇을 수집하는 요소를 추가했습니다.

## 성공 요인

### 검증된 메커니즘
Eatventure로 검증된 중독성 있는 메커니즘을 그대로 활용했습니다.

### 새로운 타겟층
레스토랑에 관심 없던 SF 팬들을 새로운 타겟으로 확보했습니다.

### 빠른 시장 진입
원작의 성공을 보고 빠르게 개발하여 시장 기회를 포착했습니다.

## 수익화

- 광고 기반 수익 2배
- 오프라인 수익 증가 IAP
- 특별 장비 패키지

> "같은 메커니즘, 다른 테마. 그것만으로도 새로운 시장이 열린다."

## 결론

Idle Outpost는 검증된 메커니즘을 새로운 테마로 성공적으로 변형한 패스트 팔로워의 모범 사례입니다. Eatventure의 핵심 재미는 유지하면서도 우주 기지라는 독자적인 정체성을 확립했습니다.`
  },
  {
    id: 6,
    category: 'fast-follower',
    title: 'Tiny Warriors (Saygames)',
    excerpt: 'Saygames의 Tiny Warriors가 보여준 장르 결합 전략. 서로 다른 메커니즘을 어떻게 조화롭게 결합해 새로운 재미를 창출했는지 분석합니다.',
    date: '2026-01-03',
    categoryColor: '#2f4f4f',
    content: `# Tiny Warriors - 장르 결합의 마스터피스

Saygames의 Tiny Warriors는 여러 히트작의 메커니즘을 조화롭게 결합하여 새로운 재미를 창출한 사례입니다.

## 결합된 메커니즘

### We Are Warriors의 자동 전진
유닛이 자동으로 전진하며 전투하는 핵심 메커니즘을 차용했습니다.

### Archero의 로그라이트 요소
스테이지마다 랜덤 업그레이드를 선택하는 로그라이트 요소를 추가했습니다.

### Merge 게임의 유닛 합성
유닛을 합성하여 더 강한 유닛을 만드는 머지 메커니즘을 결합했습니다.

## 조화의 비결

### 1. 메커니즘 간 시너지
각 메커니즘이 서로를 강화하도록 설계했습니다.

### 2. 단계적 도입
한 번에 모든 메커니즘을 보여주지 않고 단계적으로 도입했습니다.

### 3. 균형 잡힌 비중
어느 한 메커니즘이 지나치게 강조되지 않도록 균형을 맞췄습니다.

## 성공 요인

### 복합적인 재미
여러 메커니즘이 제공하는 다양한 재미 요소가 플레이어를 계속 게임에 머물게 합니다.

### 높은 리플레이 가치
로그라이트 요소가 매번 다른 경험을 제공합니다.

### 성장의 만족감
머지 시스템이 장기적인 성장 목표를 제공합니다.

## 수익화

- 광고 기반 부활
- 특별 유닛 IAP
- 프리미엄 패스

> "여러 메커니즘의 조화, 그것이 Tiny Warriors의 성공 비결입니다."

## 결론

Tiny Warriors는 여러 히트작의 장점을 결합하여 새로운 가치를 창출한 장르 결합의 모범 사례입니다.`
  },
  {
    id: 17,
    category: 'fast-follower',
    title: '탕탕특공대 - Vampire Survivors의 모바일 진화',
    excerpt: 'Habby가 개발한 탕탕특공대는 스팀 히트작 Vampire Survivors의 핵심 재미를 모바일에 완벽히 이식한 뱀서류 게임입니다. 자동 공격과 빌드 구성의 중독성을 유지하면서도 귀여운 비주얼과 짧은 세션으로 모바일 대중화에 성공했습니다.',
    date: '2026-01-25',
    categoryColor: '#2f4f4f',
    content: `# 탕탕특공대 - Vampire Survivors의 모바일 진화

Habby가 개발한 탕탕특공대는 스팀 히트작 Vampire Survivors의 핵심 재미를 모바일에 완벽히 이식한 뱀서류 게임입니다.

## 원작 분석

### Vampire Survivors의 핵심
- 자동 공격 시스템
- 빌드 구성의 전략성
- 압도적인 화력의 쾌감
- 로그라이트 요소

## 모바일 최적화

### 1. 세션 길이 단축
원작의 30분 세션을 10-15분으로 단축했습니다.

### 2. 조작 간소화
PC의 WASD 이동을 터치 조이스틱으로 변경했습니다.

### 3. 비주얼 대중화
다크한 원작과 달리 귀여운 캐릭터로 변경하여 대중성을 높였습니다.

## 차별화 요소

### 캐릭터 시스템
다양한 캐릭터와 스킨으로 수집 요소를 강화했습니다.

### 챕터 시스템
스테이지를 챕터로 나누어 명확한 진행 목표를 제공합니다.

### 소셜 요소
친구와 순위를 비교하는 소셜 기능을 추가했습니다.

## 성공 요인

### 검증된 재미
원작의 검증된 재미를 그대로 가져왔습니다.

### 모바일 친화적
짧은 세션과 간단한 조작으로 모바일에 최적화했습니다.

### 대중적 비주얼
귀여운 비주얼로 더 넓은 타겟층을 확보했습니다.

## 수익화

- 광고 기반 보상
- 캐릭터 및 스킨 판매
- 배틀 패스

> "원작의 재미는 유지하되, 모바일에 최적화하라."

## 결론

탕탕특공대는 PC 히트작을 모바일로 성공적으로 이식한 패스트 팔로워의 모범 사례입니다.`
  },
  {
    id: 18,
    category: 'fast-follower',
    title: 'Bag Fight - Backpack Hero의 하이퍼캐주얼 변신',
    excerpt: 'Voodoo가 퍼블리싱한 Bag Fight는 인디 게임 Backpack Hero의 가방 인벤토리 퍼즐 메커니즘을 하이퍼캐주얼로 재해석한 작품입니다. 복잡한 RPG 요소를 제거하고 아이템 배치의 전략성만 남겨 빠른 성장을 이뤄냈습니다.',
    date: '2026-01-23',
    categoryColor: '#2f4f4f',
    content: `# Bag Fight - Backpack Hero의 하이퍼캐주얼 변신

Voodoo가 퍼블리싱한 Bag Fight는 인디 게임 Backpack Hero의 가방 인벤토리 퍼즐을 하이퍼캐주얼로 재해석했습니다.

## 원작 분석

### Backpack Hero의 핵심
- 가방 인벤토리 퍼즐
- 아이템 배치의 전략성
- 시너지 효과
- 로그라이트 RPG

## 하이퍼캐주얼 변환

### 1. RPG 요소 제거
복잡한 스탯, 스킬, 스토리를 모두 제거했습니다.

### 2. 메커니즘 단순화
아이템 배치의 전략성만 남기고 나머지는 자동화했습니다.

### 3. 세션 단축
한 판을 3-5분으로 단축했습니다.

## 차별화 요소

### PvP 요소
원작에 없던 실시간 PvP를 추가하여 경쟁 요소를 강화했습니다.

### 비주얼 개선
귀여운 캐릭터와 화려한 이펙트로 시각적 만족감을 높였습니다.

### 빠른 진행
원작보다 훨씬 빠른 진행 속도로 성취감을 제공합니다.

## 성공 요인

### 독특한 메커니즘
가방 퍼즐이라는 독특한 메커니즘이 차별화 포인트입니다.

### 하이퍼캐주얼 접근성
복잡한 요소를 제거하여 누구나 쉽게 즐길 수 있습니다.

### 경쟁 요소
PvP가 리플레이 가치를 높입니다.

## 수익화

- 광고 기반 보상
- 프리미엄 가방 판매
- 배틀 패스

> "복잡함을 제거하고 핵심만 남기면, 하이퍼캐주얼이 된다."

## 결론

Bag Fight는 인디 게임의 독특한 메커니즘을 하이퍼캐주얼로 성공적으로 변환한 사례입니다.`
  },
  {
    id: 20,
    category: 'fast-follower',
    title: '블럭냥! - Block Jam 3D의 로컬 감성 변신',
    excerpt: '블럭냥!은 Voodoo의 Block Jam 3D 메커니즘을 귀여운 고양이 테마로 재해석한 퍼즐 게임입니다. 슬라이드 블록 퍼즐의 핵심은 유지하면서도 고양이 캐릭터와 스토리 요소를 더해 한국 시장에서 독자적인 팬층을 확보했습니다.',
    date: '2026-01-28',
    categoryColor: '#2f4f4f',
    content: `# 블럭냥! - Block Jam 3D의 로컬 감성 변신

블럭냥!은 Block Jam 3D의 메커니즘을 귀여운 고양이 테마로 재해석한 퍼즐 게임입니다.

## 원작 분석

### Block Jam 3D의 핵심
- 슬라이드 블록 퍼즐
- 3D 비주얼
- 직관적인 조작
- 점진적 난이도

## 차별화 전략

### 1. 테마 변경
무채색 블록을 귀여운 고양이 캐릭터로 변경했습니다.

### 2. 스토리 추가
고양이들을 구출한다는 스토리를 추가하여 감정적 몰입을 높였습니다.

### 3. 캐릭터 수집
다양한 고양이 캐릭터를 수집하는 요소를 추가했습니다.

### 4. 로컬라이제이션
한국 시장에 맞는 귀여운 비주얼과 네이밍을 적용했습니다.

## 성공 요인

### 타겟 명확화
고양이를 좋아하는 한국 여성 유저를 명확히 타겟했습니다.

### 감정적 연결
고양이 구출이라는 스토리가 감정적 몰입을 만들어냅니다.

### 수집 요소
다양한 고양이 캐릭터가 장기 플레이 동기를 제공합니다.

## 로컬 시장 전략

### 한국 시장 특화
- 귀여운 비주얼 선호
- 고양이 콘텐츠 인기
- 캐릭터 수집 문화

### 커뮤니티 형성
고양이 팬들의 커뮤니티를 형성하여 충성도 높은 팬층을 확보했습니다.

## 수익화

- 광고 기반 힌트
- 고양이 캐릭터 판매
- 광고 제거 패키지

> "글로벌 히트작을 로컬 감성으로 재해석하면, 새로운 가치가 탄생한다."

## 결론

블럭냥!은 글로벌 히트작을 로컬 시장에 맞게 재해석하여 성공한 베리에이션의 모범 사례입니다. 검증된 메커니즘에 로컬 감성을 더해 독자적인 정체성을 확립했습니다.`
  },
  {
    id: 21,
    title: '고양이 스낵바 - Eatventure의 귀여운 변신',
    category: 'fast-follower',
    date: '2024.01.15',
    readTime: '8분',
    excerpt: 'Eatventure의 검증된 타이쿤 메커니즘을 귀여운 고양이 테마로 성공적으로 재해석한 게임. 2D 귀여운 비주얼과 방치형 레스토랑 경영의 완벽한 조합을 분석합니다.',
    tags: ['타이쿤', '베리에이션', '캐주얼'],
    content: `
# 고양이 스낵바 - Eatventure의 귀여운 변신

## 게임 개요

고양이 스낵바는 Eatventure의 검증된 방치형 타이쿤 메커니즘을 귀여운 고양이 캐릭터와 2D 비주얼로 성공적으로 재해석한 게임입니다. 떡볶이, 김밥, 순대 등 한국 분식 메뉴를 고양이들이 만들고 판매하는 콘셉트로, 원작의 중독성은 유지하면서도 독자적인 매력을 창출했습니다.

## 원작 분석: Eatventure

### 핵심 메커니즘
- 탭 기반 수익 창출
- 레스토랑 확장 및 업그레이드
- 방치형 수익 시스템
- 새로운 지역 언락

## 차별화 전략

### 1. 비주얼 재해석
Eatventure의 3D 비주얼을 2D 귀여운 스타일로 완전히 변경했습니다. 고양이 캐릭터들이 각자의 개성을 가지고 음식을 만드는 모습이 매력적입니다.

### 2. 테마 로컬라이제이션
글로벌 레스토랑 대신 한국 분식집이라는 독특한 테마를 선택했습니다. 이는 로컬 시장에서 강한 정체성을 만들어냈습니다.

### 3. 캐릭터 중심 스토리
단순한 경영 게임을 넘어 고양이 캐릭터들의 이야기를 담아 감정적 몰입을 높였습니다.

## 성공 요인

### 검증된 메커니즘
Eatventure로 검증된 중독성 있는 타이쿤 메커니즘을 그대로 활용했습니다. 탭의 즐거움과 성장의 만족감이 핵심입니다.

### 귀여운 비주얼
2D 귀여운 스타일이 더 넓은 타겟층, 특히 여성 유저들에게 어필했습니다.

### 독자적 정체성
원작의 메커니즘을 차용했지만, 고양이 + 한국 분식이라는 독특한 조합으로 완전히 다른 게임처럼 느껴집니다.

## 베리에이션의 교훈

### 메커니즘은 유지, 테마는 변경
검증된 재미의 핵심은 그대로 가져가되, 비주얼과 테마를 완전히 바꾸면 새로운 게임이 탄생합니다.

### 타겟 명확화
원작과 다른 타겟층(귀여운 것을 좋아하는 유저)을 명확히 설정했습니다.

### 로컬 감성 활용
한국 분식이라는 로컬 테마가 오히려 독특한 차별화 포인트가 되었습니다.

## 수익화

- 광고 기반 수익 2배
- 고양이 캐릭터 스킨 판매
- 특별 메뉴 패키지

> "같은 메커니즘, 다른 테마. 그것만으로도 완전히 새로운 게임이 된다."

## 결론

고양이 스낵바는 Eatventure의 검증된 메커니즘을 귀여운 비주얼과 로컬 테마로 성공적으로 재해석한 베리에이션의 모범 사례입니다. 원작의 재미는 유지하면서도 독자적인 정체성을 확립했습니다.
    `
  },

  // 코어루프 아이디어 아카이빙
  {
    id: 10,
    category: 'idea-archive',
    title: 'HourGlass Run - 모래시계 컨셉 러너 게임',
    excerpt: '모래시계를 좌우로 움직이며 선택지를 골라 먹고, 리버스 선택지를 먹으면 모래시계가 뒤집히는 독특한 메커니즘. 모래가 다 떨어지기 전에 골인해야 하는 창의적이고 귀여운 러너 게임입니다.',
    date: '2026-01-20',
    categoryColor: '#5a4a3a',
    videoUrl: 'https://youtube.com/shorts/hPKfRhZFA6I?si=6UcTG_EtfJ92bjc-',
    gameLink: '',
    tags: ['러너', '타임 메커니즘', '하이퍼캐주얼', '귀여운'],
    content: `# HourGlass Run - 모래시계 컨셉 러너 게임

모래시계를 좌우로 움직이며 선택지를 골라 먹고, 리버스 선택지를 먹으면 모래시계가 뒤집히는 독특한 메커니즘의 러너 게임입니다.

## 핵심 메커니즘

### 모래시계 타이머
모래가 다 떨어지기 전에 골인해야 합니다. 시간이 핵심 요소입니다.

### 리버스 메커니즘
특정 선택지를 먹으면 모래시계가 뒤집혀 시간이 리셋됩니다.

### 선택지 시스템
- 시간 증가 아이템
- 속도 증가 아이템
- 리버스 아이템

## 게임 플레이

플레이어는 모래시계를 좌우로 움직이며 유리한 선택지를 골라 먹습니다. 모래가 다 떨어지기 전에 골인하는 것이 목표입니다.

## 개발 노트

이 게임은 시간 관리와 선택의 중요성을 강조하는 러너 게임입니다. 귀여운 비주얼과 독특한 메커니즘이 조화를 이룹니다.

**영상:** https://youtube.com/shorts/hPKfRhZFA6I?si=6UcTG_EtfJ92bjc-`
  },
  {
    id: 11,
    category: 'idea-archive',
    title: 'Pencil Defense - 연필 자원 미로 디펜스',
    excerpt: 'We Are Warriors에서 영감을 받은 연필 자원 생성 시스템. 모인 연필로 길을 열고, 다가오는 지우개를 피하거나 잡으며 미로를 탈출하는 전략적 디펜스 게임입니다.',
    date: '2026-01-18',
    categoryColor: '#5a4a3a',
    videoUrl: 'https://youtube.com/shorts/w5fMh4uOrkg?si=gQCWEgX6pJuwVpud',
    gameLink: 'https://play.google.com/store/apps/details?id=com.nosugargames.mazedefense',
    tags: ['디펜스', '미로', '자원관리', '하이브리드캐주얼'],
    content: `# Pencil Defense - 연필 자원 미로 디펜스

We Are Warriors에서 영감을 받은 연필 자원 생성 시스템을 활용한 미로 디펜스 게임입니다.

## 핵심 메커니즘

### 연필 자원 시스템
시간이 지나면 연필이 자동으로 생성됩니다. 이 연필로 길을 열거나 방어할 수 있습니다.

### 미로 탈출
모인 연필로 길을 열고 미로를 탈출하는 것이 목표입니다.

### 지우개 적
다가오는 지우개를 피하거나 잡아야 합니다. 전략적 선택이 필요합니다.

## 게임 플레이

플레이어는 연필 자원을 관리하며 미로를 탈출합니다. 지우개를 피하거나 잡으며 최적의 경로를 찾아야 합니다.

## 개발 노트

We Are Warriors의 자원 관리 시스템을 미로 디펜스에 적용한 게임입니다. 전략적 깊이와 긴장감이 조화를 이룹니다.

**영상:** https://youtube.com/shorts/w5fMh4uOrkg?si=gQCWEgX6pJuwVpud
**플레이:** https://play.google.com/store/apps/details?id=com.nosugargames.mazedefense`
  },
  {
    id: 12,
    category: 'idea-archive',
    title: '몽유병 밸리 - 신개념 주사위 간단 퍼즐 게임',
    excerpt: '주사위를 밀면 숫자가 감소하고, 0이 되면 벽으로 고정되는 독특한 메커니즘. 모든 주사위를 0으로 만들어 주인공의 길을 열어주는 전략적 퍼즐 게임입니다.',
    date: '2026-01-16',
    categoryColor: '#5a4a3a',
    videoUrl: 'https://youtube.com/shorts/dme2f4ydRVI?si=HGBM3wj1COZjMLdQ',
    gameLink: '',
    tags: ['퍼즐', '주사위', '전략', '메커니즘'],
    imageUrl: 'https://static.readdy.ai/image/fc3c8cf43f99dce665e9eef96771b375/a2c93e7620f10006ed332de263ec95d6.png',
    content: `# 몽유병 밸리 - 신개념 주사위 간단 퍼즐 게임

주사위를 밀면 숫자가 감소하고, 0이 되면 벽으로 고정되는 독특한 메커니즘의 퍼즐 게임입니다.

## 핵심 메커니즘

### 주사위 감소 시스템
주사위를 밀면 숫자가 1씩 감소합니다. 0이 되면 벽으로 고정됩니다.

### 경로 생성
모든 주사위를 0으로 만들어 주인공의 길을 열어줍니다.

### 전략적 순서
어떤 주사위를 먼저 밀지 순서가 중요합니다.

## 게임 플레이

플레이어는 주사위를 밀어 모두 0으로 만들어야 합니다. 순서와 방향이 퍼즐의 핵심입니다.

## 개발 노트

단순하지만 전략적 깊이가 있는 퍼즐 게임입니다. 주사위 메커니즘이 독특한 재미를 제공합니다.

**영상:** https://youtube.com/shorts/dme2f4ydRVI?si=HGBM3wj1COZjMLdQ`
  },
  {
    id: 13,
    category: 'idea-archive',
    title: 'My Little Sauna - 사우나 관리 시뮬레이션',
    excerpt: 'Rollic의 Car Lot Management에서 영감을 받아 소재를 사우나로 변형한 하이퍼캐주얼 게임. 손님을 받고, 사우나를 업그레이드하며, 수익을 극대화하는 중독적인 관리 시뮬레이션입니다.',
    date: '2026-01-14',
    categoryColor: '#5a4a3a',
    videoUrl: 'https://youtube.com/shorts/QhkaVZLtI0w?si=ijLdzFiGdBRMjrFF',
    gameLink: '',
    tags: ['하이퍼캐주얼', '관리', '시뮬레이션', '방치형'],
    imageUrl: 'https://static.readdy.ai/image/fc3c8cf43f99dce665e9eef96771b375/1563eb0a9a49ee62570d3f6b8b22e0fd.png',
    content: `# My Little Sauna - 사우나 관리 시뮬레이션

Rollic의 Car Lot Management에서 영감을 받아 소재를 사우나로 변형한 하이퍼캐주얼 관리 게임입니다.

## 핵심 메커니즘

### 손님 관리
손님을 받고 사우나 서비스를 제공합니다.

### 업그레이드 시스템
- 사우나 시설 업그레이드
- 서비스 품질 향상
- 수용 인원 증가

### 수익 극대화
효율적인 관리로 수익을 극대화합니다.

## 게임 플레이

플레이어는 사우나를 운영하며 손님을 받고 시설을 업그레이드합니다. 중독적인 관리 시뮬레이션입니다.

## 개발 노트

Car Lot Management의 메커니즘을 사우나 테마로 재해석했습니다. 단순하지만 중독적인 게임플레이가 특징입니다.

**영상:** https://youtube.com/shorts/QhkaVZLtI0w?si=ijLdzFiGdBRMjrFF`
  },
  {
    id: 14,
    category: 'idea-archive',
    title: 'Clock Crusher - 시계 속 초침 머지 클리커',
    excerpt: '시계 속에 초침을 소환하고, 시계 속 숫자를 부수며 돈을 얻고, 초침을 머지하여 더 좋은 초침을 획득하는 하이퍼캐주얼 클리커 게임. 단순하지만 중독적인 머지 메커니즘이 핵심입니다.',
    date: '2026-01-12',
    categoryColor: '#5a4a3a',
    videoUrl: 'https://youtu.be/ntSQEZVUihY?si=Uc8Wl7GEAMcvpG9_',
    gameLink: '',
    tags: ['클리커', '머지', '하이퍼캐주얼', '방치형'],
    content: `# Clock Crusher - 시계 속 초침 머지 클리커

시계 속에 초침을 소환하고 머지하여 숫자를 부수는 하이퍼캐주얼 클리커 게임입니다.

## 핵심 메커니즘

### 초침 소환
시계 속에 초침을 소환하여 숫자를 부칩니다.

### 머지 시스템
같은 초침을 합쳐 더 강력한 초침을 만듭니다.

### 수익 창출
숫자를 부수면 돈을 얻습니다.

## 게임 플레이

플레이어는 초침을 소환하고 머지하며 시계 속 숫자를 부칩니다. 단순하지만 중독적인 클리커 게임입니다.

## 개발 노트

클리커와 머지 메커니즘을 결합한 하이퍼캐주얼 게임입니다. 시계 테마가 독특한 분위기를 만듭니다.

**영상:** https://youtu.be/ntSQEZVUihY?si=Uc8Wl7GEAMcvpG9_`
  },
  {
    id: 15,
    category: 'idea-archive',
    title: 'Loop Trap - 타워 설치가 없는 신개념 타워 디펜스',
    excerpt: '타워 설치 대신 몬스터 경로를 확장하여 기존 타워를 "잘 이용"하는 혁신적 시스템. 타워 설치조차 허들로 느끼는 논게이머 유저까지 타깃한 디펜스 게임. 루프를 만들어 바퀴 수를 증가시키는 복잡한 퍼즐성과 로그라이트 요소를 결합했습니다.',
    date: '2026-01-10',
    categoryColor: '#5a4a3a',
    videoUrl: 'https://youtube.com/shorts/Xr7OqzSFEHU?si=0knDWNdzishyrXg9',
    gameLink: 'https://play.google.com/store/apps/details?id=com.suddenloop.looptrap',
    tags: ['타워디펜스', '퍼즐', '로그라이트', '혁신메커니즘'],
    imageUrl: 'https://static.readdy.ai/image/fc3c8cf43f99dce665e9eef96771b375/71943806a1819ace3499a40a5a1eb391.png',
    content: `# Loop Trap - 타워 설치가 없는 신개념 타워 디펜스

타워 설치 대신 몬스터 경로를 확장하여 기존 타워를 활용하는 혁신적인 디펜스 게임입니다.

## 핵심 메커니즘

### 경로 확장 시스템
타워를 설치하는 대신 몬스터의 경로를 확장합니다.

### 기존 타워 활용
맵에 이미 배치된 타워를 최대한 활용하는 전략이 필요합니다.

### 루프 생성
경로를 루프로 만들어 몬스터가 타워를 여러 번 지나가게 합니다.

## 게임 플레이

플레이어는 경로를 확장하여 몬스터가 타워를 최대한 많이 지나가도록 만듭니다. 퍼즐과 전략이 결합된 게임플레이입니다.

## 개발 노트

타워 설치라는 전통적인 메커니즘을 제거하고 경로 확장으로 대체한 혁신적인 디펜스 게임입니다. 논게이머도 쉽게 즐길 수 있습니다.

**영상:** https://youtube.com/shorts/Xr7OqzSFEHU?si=0knDWNdzishyrXg9
**플레이:** https://play.google.com/store/apps/details?id=com.suddenloop.looptrap`
  },

  // 히트 가능성 예측 리포트 (프리미엄)
  {
    id: 22,
    category: 'hit-prediction',
    title: '2025년 모바일 게임 히트 예측 TOP 10',
    excerpt: '데이터 분석과 시장 트렌드를 기반으로 2025년 히트할 가능성이 높은 게임 장르와 메커니즘을 예측합니다. AI 기반 분석 리포트로 개발 방향성을 제시합니다.',
    date: '2026-01-30',
    categoryColor: '#4a3a5a',
    content: `# 2025년 모바일 게임 히트 예측 TOP 10

데이터 분석과 시장 트렌드를 기반으로 2025년 히트할 가능성이 높은 게임 장르와 메커니즘을 예측합니다.

## 예측 방법론

### 데이터 소스
- 앱스토어 차트 분석
- 소셜 미디어 트렌드
- 게임 커뮤니티 반응
- 퍼블리셔 동향

### AI 분석
머신러닝 모델을 활용하여 과거 히트작의 패턴을 분석하고 미래를 예측합니다.

## TOP 10 예측

### 1. 하이브리드 로그라이트
**예측 근거:** Archero, Vampire Survivors의 지속적인 인기

### 2. 소셜 파티 게임
**예측 근거:** Among Us, Fall Guys의 성공 패턴 재현 가능성

### 3. AI 기반 개인화 게임
**예측 근거:** AI 기술 발전과 개인화 트렌드

### 4. 블록체인 게임 2.0
**예측 근거:** 1세대 실패 교훈을 반영한 새로운 시도

### 5. 하이퍼캐주얼 퍼즐 진화
**예측 근거:** Block Jam 3D 류의 3D 퍼즐 지속 성장

### 6. 방치형 RPG 하이브리드
**예측 근거:** 방치형과 RPG의 성공적 결합 사례 증가

### 7. 리듬 게임 르네상스
**예측 근거:** K-POP 글로벌 인기와 시너지

### 8. 생존 크래프트 모바일화
**예측 근거:** PC 생존 게임의 모바일 이식 트렌드

### 9. 비대칭 멀티플레이어
**예측 근거:** Dead by Daylight Mobile의 성공

### 10. 메타버스 소셜 게임
**예측 근거:** Z세대의 메타버스 선호도

## 투자 추천

### 높은 확률
하이브리드 로그라이트, 하이퍼캐주얼 퍼즐

### 중간 확률
소셜 파티 게임, 방치형 RPG

### 높은 리스크, 높은 리턴
AI 게임, 블록체인 게임

> "데이터는 거짓말하지 않는다. 하지만 해석은 신중해야 한다."

## 결론

2025년은 하이브리드 장르와 AI 기술이 게임 시장을 주도할 것으로 예측됩니다.`
  },
  {
    id: 23,
    category: 'hit-prediction',
    title: '실패한 게임들의 공통점 - 2024년 부검 리포트',
    excerpt: '2024년 출시되었지만 실패한 게임들을 분석하여 공통적인 실패 요인을 도출합니다. 같은 실수를 반복하지 않기 위한 필수 리포트입니다.',
    date: '2026-01-28',
    categoryColor: '#4a3a5a',
    content: `# 실패한 게임들의 공통점 - 2024년 부검 리포트

2024년 출시되었지만 실패한 게임들을 분석하여 공통적인 실패 요인을 도출합니다.

## 분석 대상

### 선정 기준
- 2024년 출시
- 초기 기대치 높았으나 실패
- 충분한 마케팅 예산 투입
- 6개월 내 서비스 종료 또는 유저 급감

## 공통 실패 요인

### 1. 과도한 복잡성
**사례:** Project X
- 너무 많은 시스템
- 높은 학습 곡선
- 모바일 환경 부적합

**교훈:** 단순함이 미덕이다.

### 2. 수익화 실패
**사례:** Game Y
- 공격적인 IAP
- Pay-to-Win 구조
- 유저 이탈 가속화

**교훈:** 유저 경험을 해치지 않는 수익화가 중요하다.

### 3. 타겟 불명확
**사례:** Game Z
- 모호한 타겟 유저
- 일관성 없는 디자인
- 마케팅 메시지 혼란

**교훈:** 명확한 타겟 설정이 필수다.

### 4. 기술적 문제
**사례:** Game A
- 잦은 크래시
- 최적화 부족
- 배터리 과소비

**교훈:** 기술적 안정성이 우선이다.

### 5. 시장 타이밍 실패
**사례:** Game B
- 트렌드 종료 시점 출시
- 경쟁작 포화 상태
- 차별화 부족

**교훈:** 시장 타이밍이 중요하다.

### 6. 콘텐츠 부족
**사례:** Game C
- 초반 콘텐츠만 풍부
- 엔드 콘텐츠 부재
- 빠른 이탈

**교훈:** 장기 콘텐츠 계획이 필요하다.

### 7. 커뮤니티 무시
**사례:** Game D
- 유저 피드백 무시
- 소통 부재
- 신뢰 상실

**교훈:** 커뮤니티와의 소통이 중요하다.

## 실패 패턴 분석

### 초기 실패 (1개월 내)
- 기술적 문제
- 과도한 복잡성
- 타겟 불명확

### 중기 실패 (3개월 내)
- 콘텐츠 부족
- 수익화 실패
- 커뮤니티 무시

### 후기 실패 (6개월 내)
- 업데이트 부족
- 경쟁작 등장
- 운영 포기

## 실패 회피 전략

### 출시 전
- 충분한 테스트
- 명확한 타겟 설정
- 시장 타이밍 분석

### 출시 후
- 빠른 버그 수정
- 유저 피드백 반영
- 지속적인 콘텐츠 업데이트

> "실패에서 배우지 못하면, 같은 실패를 반복한다."

## 결론

실패한 게임들의 공통점을 분석하면, 성공의 조건이 보입니다. 같은 실수를 반복하지 마세요.`
  },
  {
    id: 24,
    category: 'hit-prediction',
    title: '장르별 성공 확률 분석 - 2025년 전망',
    excerpt: '하이퍼캐주얼, 하이브리드캐주얼, 미드코어 등 각 장르별 성공 확률과 시장 포화도를 분석합니다. 어떤 장르에 집중해야 할지 데이터로 답합니다.',
    date: '2026-01-25',
    categoryColor: '#4a3a5a',
    content: `# 장르별 성공 확률 분석 - 2025년 전망

하이퍼캐주얼, 하이브리드캐주얼, 미드코어 등 각 장르별 성공 확률과 시장 포화도를 분석합니다.

## 분석 방법론

### 데이터 수집
- 2020-2024년 출시 게임 10,000개 분석
- 장르별 성공률 계산
- 시장 포화도 측정

### 성공 기준
- 100만 다운로드 이상
- 6개월 이상 운영
- 수익성 확보

## 장르별 분석

### 하이퍼캐주얼
**성공 확률:** 3.2%
**시장 포화도:** 매우 높음
**평균 개발 기간:** 2-3개월
**평균 개발 비용:** $50K-$100K

**전망:**
- 시장 포화로 성공 확률 하락
- 퍼블리셔 의존도 높음
- 독창적 메커니즘 필수

**추천 여부:** ⚠️ 신중 검토 필요

### 하이브리드캐주얼
**성공 확률:** 8.7%
**시장 포화도:** 중간
**평균 개발 기간:** 6-9개월
**평균 개발 비용:** $200K-$500K

**전망:**
- 가장 높은 성공 확률
- 메타 게임 중요성 증가
- 로그라이트 요소 효과적

**추천 여부:** ✅ 강력 추천

### 미드코어
**성공 확률:** 5.1%
**시장 포화도:** 높음
**평균 개발 기간:** 12-24개월
**평균 개발 비용:** $1M-$5M

**전망:**
- 높은 진입 장벽
- 장기 운영 가능
- IP 중요성 높음

**추천 여부:** ⚠️ 대형 스튜디오 권장

### 방치형
**성공 확률:** 6.3%
**시장 포화도:** 중간
**평균 개발 기간:** 4-6개월
**평균 개발 비용:** $100K-$300K

**전망:**
- 안정적인 성공률
- 하이브리드 결합 트렌드
- 장기 운영 용이

**추천 여부:** ✅ 추천

### 퍼즐
**성공 확률:** 4.8%
**시장 포화도:** 매우 높음
**평균 개발 기간:** 3-6개월
**평균 개발 비용:** $100K-$300K

**전망:**
- 전통적 강자들 독점
- 혁신적 메커니즘 필수
- 3D 전환 트렌드

**추천 여부:** ⚠️ 차별화 필수

### 로그라이트
**성공 확률:** 7.2%
**시장 포화도:** 낮음
**평균 개발 기간:** 8-12개월
**평균 개발 비용:** $300K-$800K

**전망:**
- 성장 중인 시장
- 하이브리드 결합 효과적
- 리플레이 가치 높음

**추천 여부:** ✅ 추천

## 2025년 추천 전략

### 최우선 추천
1. 하이브리드캐주얼 + 로그라이트
2. 방치형 + RPG 요소

### 중간 추천
3. 3D 퍼즐 혁신
4. 소셜 파티 게임

### 신중 검토
5. 순수 하이퍼캐주얼
6. 전통적 퍼즐

## 예산별 추천

### $100K 이하
- 하이퍼캐주얼 (퍼블리셔 파트너십)
- 단순 방치형

### $100K-$500K
- 하이브리드캐주얼
- 방치형 하이브리드
- 로그라이트

### $500K 이상
- 미드코어
- 대규모 멀티플레이어

> "데이터는 방향을 제시하지만, 실행은 당신의 몫입니다."

## 결론

2025년은 하이브리드캐주얼과 로그라이트 장르가 가장 높은 성공 확률을 보일 것으로 예측됩니다.`
  }
];

export const featuredInsights = [
  {
    id: 1,
    title: '히트 코어루프',
    description: '글로벌 히트작들의 핵심 코어루프를 분석하고 성공 요인을 파헤칩니다',
    icon: 'fire',
    color: 'from-[#8b4513] to-[#654321]'
  },
  {
    id: 2,
    title: '패스트 팔로워',
    description: '베리에이션과 조합 전략으로 시장 기회를 포착하는 방법을 연구합니다',
    icon: 'rocket',
    color: 'from-[#2f4f4f] to-[#1f3f3f]'
  },
  {
    id: 3,
    title: '해든의 코어루프 아이디어 아카이빙',
    description: '게임기획자 해든의 아이디어 낙서. 직접 플레이 가능한 게임 프로토타입과 개발 노트를 무료로 제공합니다',
    icon: 'gamepad',
    color: 'from-[#5a4a3a] to-[#4a3a2a]'
  },
  {
    id: 4,
    title: '히트 가능성 예측 리포트',
    description: '데이터 기반 히트 예측과 장르별 성공 확률 분석을 독점 제공합니다',
    icon: 'chart',
    color: 'from-[#4a3a5a] to-[#3a2a4a]'
  }
];
